webpackJsonp([142807904292071],{

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var data = __webpack_require__(153);
	
	if (({"NODE_ENV":"production","PUBLIC_DIR":"/codebuild/output/src044587584/src/public"}).gatsby_executing_command === 'develop') {
	  // Add some items with testing values
	  data.push();
	}
	
	module.exports = data;

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

	module.exports = [{"name":"Brian Slingsby","personType":"STAFF","memoryDate":"1980","submissionDate":1474885780685,"text":"It was a terrible thing. Because nobody expected it. Nobody outside the directors knew it was going to happen. I mean – I charged - filled up every pot on the Friday night. Just came round - “We're closing!”\nLeaving that aside. That was the thing to do. Because we had all that batch mix ready for the weekend. What are you going to do with it? You don't want it left there if you are going to close. You want it melted down into something which is innocuous. But I mean it was such a shock – such a shock - it devastated people. Lots of people who had worked at the place for ages, and their families had worked at the place for ages. It was all very sad as well. I won't say you can blame anything it was just how things had gone.\nBecause within another ten years all the other major factories had closed as well. It was the ingress of technology you know. Technology creeps in at the bottom end and takes all your bread and butter stuff away. And then you are only left with the stuff after that. You see melting from a tank furnace is totally different from melting from a pot furnace. Its a different world - but it was a very sad time.","relatedItems":[]},{"name":"Brian Slingsby","personType":"STAFF","memoryDate":"1980","submissionDate":1474885780684,"text":"The phone went and it was Roy Raiken's wife. She said “He's away. I've had the police on. There's propane escaping.” I thought 'Oh my God'. Because the electric railway line - your main Euston line - was just across the road from it. So I got in the car and sped off down there. First of all they would not let me in. There was everybody in the land there – police, ambulance, water, fire brigade. As soon as I walked through the arch I thought 'My time is up.' Because there was propane vapour about that deep completely covering the car park. I thought 'One spark here and we are all goners.'","relatedItems":[]}]

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(156);
	var parse = __webpack_require__(155);
	var formats = __webpack_require__(68);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(69);
	var formats = __webpack_require__(68);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	var encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    merge: merge
	};


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(149);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _Profile = __webpack_require__(127);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	var dateFormat = function dateFormat(timestamp) {
	  var date = new Date(timestamp);
	  return months[date.getMonth()] + ' ' + date.getFullYear();
	};
	
	var paragraphs = function paragraphs(text) {
	  return text.split('\n').map(function (part, index) {
	    return _react2.default.createElement(
	      'p',
	      { key: index },
	      part
	    );
	  });
	};
	
	exports.default = function (_ref) {
	  var submissionDate = _ref.submissionDate,
	      name = _ref.name,
	      personType = _ref.personType,
	      text = _ref.text,
	      memoryDate = _ref.memoryDate,
	      relatedItems = _ref.relatedItems;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.top },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.profileIcon },
	        _react2.default.createElement(_Profile2.default, { size: 64, color: '#fff' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.nameAndTime },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.name },
	          _react2.default.createElement(
	            'span',
	            null,
	            name
	          ),
	          personType !== 'OTHER' && _text2.default.PERSON_TYPES[personType] && _react2.default.createElement(
	            'span',
	            { className: _stylesModule2.default.badge },
	            _text2.default.PERSON_TYPES[personType]
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.date },
	          'Submitted ',
	          dateFormat(submissionDate)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.message },
	      memoryDate && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.memoryDate },
	        'Memory date: ',
	        memoryDate
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.text },
	        paragraphs(text)
	      ),
	      relatedItems.length > 0 && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.relatedItems },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Related Items'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          relatedItems.map(function (relatedItem) {
	            return _react2.default.createElement(
	              'li',
	              { key: relatedItem },
	              _react2.default.createElement(_itemLink2.default, {
	                id: relatedItem,
	                imageSizes: '(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 4rem), (min-width: 768px) calc(33vw - 6rem), calc(50vw - 10rem)'
	              })
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-memory----styles-module---container----ZmXk","top":"src-components-memory----styles-module---top---3yLvo","profileIcon":"src-components-memory----styles-module---profileIcon---2b0Cn","message":"src-components-memory----styles-module---message---1r3xp","nameAndTime":"src-components-memory----styles-module---nameAndTime---pXTpc","name":"src-components-memory----styles-module---name---qkEkw","badge":"src-components-memory----styles-module---badge---7N4p5","date":"src-components-memory----styles-module---date---DKn7g","text":"src-components-memory----styles-module---text---2Ncfk","memoryDate":"src-components-memory----styles-module---memoryDate---2nt8_","relatedItems":"src-components-memory----styles-module---relatedItems---2tfvG"};

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(150);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Search = __webpack_require__(57);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      applySearchTerm = _ref.applySearchTerm;
	  return _react2.default.createElement(
	    'form',
	    {
	      className: _stylesModule2.default.container,
	      onSubmit: function onSubmit(event) {
	        event.preventDefault();
	        applySearchTerm();
	      }
	    },
	    _react2.default.createElement(
	      'label',
	      { className: 'a11y-hide', htmlFor: 'search-term' },
	      'Search term'
	    ),
	    _react2.default.createElement('input', {
	      type: 'text',
	      id: 'search-term',
	      name: 'search-term',
	      placeholder: 'Enter a search term',
	      value: value,
	      onChange: onChange
	    }),
	    _react2.default.createElement(
	      'button',
	      { onClick: applySearchTerm },
	      _react2.default.createElement(_Search2.default, { size: 16 })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-search-box----styles-module---container---2CNmU"};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _qs = __webpack_require__(154);
	
	var _stylesModule = __webpack_require__(659);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _memories = __webpack_require__(99);
	
	var _memories2 = _interopRequireDefault(_memories);
	
	var _glass = __webpack_require__(129);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	var _memories3 = __webpack_require__(191);
	
	var _memories4 = _interopRequireDefault(_memories3);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _gridRow = __webpack_require__(84);
	
	var _gridRow2 = _interopRequireDefault(_gridRow);
	
	var _gridCol = __webpack_require__(122);
	
	var _gridCol2 = _interopRequireDefault(_gridCol);
	
	var _subHeading = __webpack_require__(48);
	
	var _subHeading2 = _interopRequireDefault(_subHeading);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	var _memory = __webpack_require__(123);
	
	var _memory2 = _interopRequireDefault(_memory);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _searchBox = __webpack_require__(124);
	
	var _searchBox2 = _interopRequireDefault(_searchBox);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _tileOne = __webpack_require__(70);
	
	var _tileOne2 = _interopRequireDefault(_tileOne);
	
	var _tileTwo = __webpack_require__(71);
	
	var _tileTwo2 = _interopRequireDefault(_tileTwo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TEXT = {
	  LIMITED_RESULTS_LABEL: 'Showing only the first 4 results',
	  LIMITED_RESULTS_BUTTON: 'See all results',
	
	  SHOWING_ALL_RESULTS_LABEL: 'Found {x} results',
	  SHOWING_ALL_RESULTS_BUTTON: 'See more search options',
	
	  NO_RESULTS_LABEL: 'No results found',
	  NO_RESULTS_BUTTON: 'See more search options'
	};
	
	var RESULTS_TO_SHOW = 4;
	
	var searchGlass = function searchGlass(searchTerm) {
	  return (0, _glass2.default)(_glassData2.default, searchTerm);
	};
	var searchMemories = function searchMemories(searchTerm) {
	  return (0, _memories4.default)(_memories2.default, searchTerm);
	};
	
	var getLabelText = function getLabelText(amountFound) {
	  if (amountFound > RESULTS_TO_SHOW) {
	    return TEXT.LIMITED_RESULTS_LABEL;
	  } else if (amountFound > 0) {
	    return TEXT.SHOWING_ALL_RESULTS_LABEL.replace('{x}', amountFound);
	  } else {
	    return TEXT.NO_RESULTS_LABEL;
	  }
	};
	var getButtonText = function getButtonText(amountFound) {
	  if (amountFound > RESULTS_TO_SHOW) {
	    return TEXT.LIMITED_RESULTS_BUTTON;
	  } else if (amountFound > 0) {
	    return TEXT.SHOWING_ALL_RESULTS_BUTTON;
	  } else {
	    return TEXT.NO_RESULTS_BUTTON;
	  }
	};
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.updateSearchTerm = function (event) {
	      var value = event.target.value;
	      _this.setState(function (state) {
	        return { searchTerm: value };
	      });
	    };
	
	    _this.performSearch = function () {
	      ga('send', {
	        hitType: 'event',
	        eventCategory: 'Search',
	        eventAction: 'Submit',
	        eventLabel: 'searchPage'
	      });
	      _this.setState(function (state) {
	        return {
	          inUseSearchTerm: state.searchTerm,
	          filteredGlass: searchGlass(state.searchTerm),
	          filteredMemories: searchMemories(state.searchTerm)
	        };
	      });
	    };
	
	    _this.navigateToSearch = function (path) {
	      return (0, _gatsbyLink.navigateTo)('/' + path + '?term=' + encodeURIComponent(_this.state.inUseSearchTerm));
	    };
	
	    _this.navigateToGlassSearch = function () {
	      return _this.navigateToSearch('glass');
	    };
	
	    _this.navigateToMemorySearch = function () {
	      return _this.navigateToSearch('memories');
	    };
	
	    var query = (0, _qs.parse)(typeof location !== 'undefined' && location.search && location.search.slice(1));
	
	    var searchTerm = query.term || '';
	
	    _this.state = {
	      searchTerm: searchTerm,
	      inUseSearchTerm: searchTerm,
	
	      filteredGlass: searchGlass(searchTerm),
	      filteredMemories: searchMemories(searchTerm)
	    };
	    return _this;
	  }
	
	  Search.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Search Whitefriars' }),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.container },
	        _react2.default.createElement(
	          _backgroundContainer2.default,
	          { src: _room2.default },
	          _react2.default.createElement(
	            _gridWrap2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.header },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Search Everything'
	              ),
	              _react2.default.createElement(_searchBox2.default, {
	                value: this.state.searchTerm,
	                onChange: this.updateSearchTerm,
	                applySearchTerm: this.performSearch
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gridWrap2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.content },
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.glassResults },
	              _react2.default.createElement(_subHeading2.default, { text: 'Glass Results' }),
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.textAndButton },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  getLabelText(this.state.filteredGlass.length)
	                ),
	                _react2.default.createElement(_pillButton2.default, {
	                  small: true,
	                  text: getButtonText(this.state.filteredGlass.length),
	                  onClick: this.navigateToGlassSearch
	                })
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                this.state.filteredGlass.slice(0, RESULTS_TO_SHOW).map(function (object) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: object.id },
	                    _react2.default.createElement(_itemLink2.default, {
	                      id: object.id,
	                      imageSizes: '(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 2.75rem), (min-width: 768px) calc(50vw - 5rem), calc(100vw - 4rem)'
	                    })
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.memoryResults },
	              _react2.default.createElement(_subHeading2.default, { text: 'Memory Results' }),
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.textAndButton },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  getLabelText(this.state.filteredMemories.length)
	                ),
	                _react2.default.createElement(_pillButton2.default, {
	                  small: true,
	                  text: getButtonText(this.state.filteredMemories.length),
	                  onClick: this.navigateToMemorySearch
	                })
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                this.state.filteredMemories.slice(0, RESULTS_TO_SHOW).map(function (memoryDetails) {
	                  return _react2.default.createElement(
	                    'li',
	                    { key: memoryDetails.submissionDate },
	                    _react2.default.createElement(_memory2.default, memoryDetails)
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_siteFooter2.default, null)
	    );
	  };
	
	  return Search;
	}(_react.Component);
	
	exports.default = Search;
	module.exports = exports['default'];

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-search----styles-module---container---BGddx","header":"src-page-components-search----styles-module---header---3aaeh","content":"src-page-components-search----styles-module---content---2oh3x","textAndButton":"src-page-components-search----styles-module---textAndButton---3rw0o","glassResults":"src-page-components-search----styles-module---glassResults---3xPwi","memoryResults":"src-page-components-search----styles-module---memoryResults---1uCV2"};

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _search = __webpack_require__(355);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _search2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = searchFilterAndSortMemories;
	
	var _glassData = __webpack_require__(24);
	
	var filterMemories = function filterMemories(allMemories, searchTerm, typeFilter) {
	  var filteredMemories = allMemories;
	
	  if (typeFilter && typeFilter !== 'all') {
	    filteredMemories = filteredMemories.filter(function (memory) {
	      return memory.personType === typeFilter;
	    });
	  }
	
	  if (searchTerm) {
	    var lowerCaseSearchTerm = searchTerm.toLowerCase();
	
	    filteredMemories = filteredMemories.filter(function (memory) {
	      return memory.name.toLowerCase().includes(lowerCaseSearchTerm) || memory.text.toLowerCase().includes(lowerCaseSearchTerm) || memory.relatedItems.reduce(function (result, id) {
	        return result || _glassData.dataByIds[id].title.toLowerCase().includes(lowerCaseSearchTerm);
	      }, false);
	    });
	  }
	
	  return filteredMemories;
	};
	
	var sortMemories = function sortMemories(filteredMemories, sort) {
	  if (sort === 'date:asc') {
	    // Oldest First
	    filteredMemories.sort(function (a, b) {
	      return a.submissionDate > b.submissionDate ? 1 : 0;
	    });
	  } else if (sort === 'name:asc') {
	    // A First
	    filteredMemories.sort(function (a, b) {
	      return a.name.localeCompare(b.name);
	    });
	  } else if (sort === 'name:desc') {
	    // Z First
	    filteredMemories.sort(function (a, b) {
	      return b.name.localeCompare(a.name);
	    });
	  } else {
	    // Default is date:asc - Newest First
	    filteredMemories.sort(function (a, b) {
	      return a.submissionDate < b.submissionDate ? 1 : 0;
	    });
	  }
	
	  return filteredMemories;
	};
	
	function searchFilterAndSortMemories(memories, searchTerm, typeFilter, sortOrder) {
	  return sortMemories(filterMemories(memories, searchTerm, typeFilter), sortOrder);
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-search-js-8d4e6092c0b7880e272c.js